"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RELATIONS_FOR_ORGANIZATION_USER = exports.DEFAULT_CREATE_CUSTOMER_OPTIONS = exports.LIMIT_CUSTOMERS_FETCH_AMOUNT = void 0;
exports.LIMIT_CUSTOMERS_FETCH_AMOUNT = 1000;
exports.DEFAULT_CREATE_CUSTOMER_OPTIONS = {
    saveCustomer: true,
    sendCustomerNotification: true,
    allowExistingCustomer: false,
    requireNewUser: false,
};
exports.RELATIONS_FOR_ORGANIZATION_USER = ['user', 'user.organizationUsers'];
//# sourceMappingURL=customers.consts.js.map